import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import StatCard from "../../components/common/StatCard";
import { DASHBOARD_STRINGS, COMMON_STRINGS } from "../../constants/strings";

import PeopleIcon from "@mui/icons-material/People";
import EngineeringIcon from "@mui/icons-material/Engineering";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import UserBarChart from "../../components/charts/UserBarChart";
import StatusPieChart from "../../components/charts/StatusPieChart";

import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice";

import { getDashboardStats } from "../../services/api";

import "../table-common.css";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const [stats, setStats] = useState({
    users: 0,
    providers: 0,
    revenue: 0,
    tickets: 0,
  });

  const [loading, setLoading] = useState(false);

  // ================= FETCH =================
  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const res = await getDashboardStats();
      const data = res.data?.data;

      setStats({
        users: data?.totalUsers || 0,
        providers: data?.totalProviders || 0,
        revenue: data?.totalRevenue || 0,
        tickets: data?.pendingTickets || 0,
      });
    } catch (err: any) {
      dispatch(
        showSnackbar({
          message: err.message || COMMON_STRINGS.SOMETHING_WENT_WRONG,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return (
    <Box>
      {/* 🔥 STATS */}
      <Box className="dashboard-grid">
        <StatCard
          title={DASHBOARD_STRINGS.TOTAL_USERS}
          value={stats.users}
          icon={<PeopleIcon />}
          bgColor="var(--primary-soft)"
          color="var(--primary-main)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.TOTAL_PROVIDERS}
          value={stats.providers}
          icon={<EngineeringIcon />}
          bgColor="var(--blue-soft)"
          color="var(--blue)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.TOTAL_REVENUE}
          value={`₹${stats.revenue}`}
          icon={<CurrencyRupeeIcon />}
          bgColor="var(--success-soft)"
          color="var(--success)"
          loading={loading}
        />

        <StatCard
          title={DASHBOARD_STRINGS.PENDING_TICKETS}
          value={stats.tickets}
          icon={<SupportAgentIcon />}
          bgColor="var(--warning-soft)"
          color="var(--warning)"
          loading={loading}
        />
      </Box>

      {/* 🔥 ANALYTICS */}
      <Box className="dashboard-section">
        <Typography className="dashboard-title">
          {DASHBOARD_STRINGS.ANALYTICS_OVERVIEW}
        </Typography>

        <Box className="dashboard-chart-grid">
          <Box className="dashboard-card">
            <Typography sx={{ mb: 1 }}>
              {DASHBOARD_STRINGS.USERS_PROVIDERS}
            </Typography>
            <UserBarChart data={stats} />
          </Box>

          <Box className="dashboard-card">
            <Typography sx={{ mb: 1 }}>
              {DASHBOARD_STRINGS.REVENUE_TICKETS}
            </Typography>
            <StatusPieChart data={stats} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardPage;
